import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EncryptionAndDecryption } from 'src/app/COMMON-LOGIC/EncryptionAndDecryption';
import { CustomErrorsHandlerService } from 'src/app/_services/custom-errors-handler.service';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { SocialAuthentication, SocialAuthUrlParams } from 'src/app/common-class/social-authentication';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-social-authentication',
  templateUrl: './social-authentication.component.html',
  styleUrls: ['./social-authentication.component.css']
})
export class SocialAuthenticationComponent implements OnInit {
  isMobile: boolean;
  showLoader = true;
  productTitle: string;
  isSubscriptionModal: boolean;
  urlParams: SocialAuthUrlParams;
  socialAuth: SocialAuthentication;

  constructor(public service: ParticipationDataService,
    private activatedRoute: ActivatedRoute,
    private errorsHandlerService: CustomErrorsHandlerService,) { }

  GetUrlData() {
    this.activatedRoute.queryParams.subscribe(async params => {
      const state = (params['state'] == "" || params['state'] == undefined) ? "" : params['state']
      this.urlParams.surveyKeyAfterAuth = state.split(',')[0] || '';
      this.urlParams.k = (params['k'] == "" || params['k'] == undefined) ? "" : params['k'];
      this.urlParams.code = (params['code'] == "" || params['code'] == undefined) ? "" : params['code'];
      this.urlParams.error = (params['error'] == "" || params['error'] == undefined) ? "" : params['error'];
      if (this.urlParams.k && this.urlParams.surveyKeyAfterAuth) {
        this.urlParams.surveyKeyAfterAuth = this.DecryptForLinkedIn(this.urlParams.surveyKeyAfterAuth);
      }
    });
  }

  ngOnInit(): void {    
    this.isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

    this.productTitle = environment.productName;
    
    this.urlParams = new SocialAuthUrlParams();
    this.GetUrlData();

    const url = "SurveyAuth?k=" + this.urlParams.k;
    this.service.GetDataPropAll(url, JSON.stringify(
      EncryptionAndDecryption.EncryptionData(
        '123456$#@$^@1ERF',
        JSON.stringify(this.urlParams),
      ),
    )).subscribe(async (data: unknown) => {
      const arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
      this.socialAuth = await JSON.parse(arrData);
      
      if (this.socialAuth.literalFbTags) {
        this.injectLiteralFbTags(this.socialAuth.literalFbTags);
      }

      if (this.socialAuth.IsRedirectToSurvey && this.urlParams.surveyKeyAfterAuth) {
        window.location.replace(this.socialAuth.strProductHostUrl + "survey/form?k=" + (this.urlParams.surveyKeyAfterAuth == "LinkedIn" ? this.urlParams.k : this.urlParams.surveyKeyAfterAuth) + "&auth=true");
      }

      const head = document.getElementsByTagName('head')[0];

      const node = document.createElement('script');
      node.src = 'survey/assets//js/Anuglar_Survey_jquery.min.js?v=30052022';
      node.type = 'text/javascript';

      const node1 = document.createElement('script');
      node1.src = 'survey/assets//js/jquery-ui.min.js?v=30052022';
      node1.type = 'text/javascript';

      const node2 = document.createElement('script');
      node2.src = 'survey/assets//js/Survey_jquery.nicescroll.js';
      node2.type = 'text/javascript';

      const node4 = document.createElement('script');
      node4.src = 'survey/assets//js/Survey_jquery.ui.touch-punch.min.js?ver=13.0';
      node4.type = 'text/javascript';

      const style2 = document.createElement('link');
      style2.id = 'css-styling';
      style2.rel = 'stylesheet';
      style2.href = 'survey/assets/jquery-ui.min.css?key=11.25.25-07-2018';

      const style3 = document.createElement('link');
      style3.id = 'css-styling';
      style3.rel = 'stylesheet';
      style3.href = 'survey/assets/ng-common-pm.css';

      head.appendChild(style2);
      head.appendChild(style3);
      head.appendChild(node);
      head.appendChild(node1);
      head.appendChild(node2);
      head.appendChild(node4);

      setTimeout(() => {
        this.showLoader = false;
      }, 250);

    }, error => {
      this.errorsHandlerService.handleError(error);
      if (error.name == "HttpErrorResponse") {
        window.location.replace("..survey/sd?err=1&ng=2&cn=0");
      }
    });
  }

  FaceBookSignInParticipation() {
    const strfbhost = this.socialAuth.strProductHostUrl + "survey/socialauth?scope=email";
    const strfburl = "https://graph.facebook.com/oauth/authorize?client_id=" + this.socialAuth.FacebookKey + "&redirect_uri=" + strfbhost + "&state=" + this.urlParams.k + ",user_birthday,user_location&display=page";
    window.location.replace(strfburl);
  }

  AuthorizeLinkedIn() {
    const strStateEncr = this.EncryptForLinkedIn("LinkedIn");
    const strlnhost = this.socialAuth.strProductHostUrl + "survey/socialauth?k=" + this.urlParams.k;
    const strlnurl = "https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=" + this.socialAuth.LinkedInKey + "&redirect_uri=" + strlnhost + "&state=" + strStateEncr + "&scope=r_liteprofile+r_emailaddress";
    window.location.replace(strlnurl);
  }

  EncryptForLinkedIn(strOriginal: string): string {
    let strNew = "";
    for (let intCount = 1; intCount <= strOriginal.length; intCount++) {
      if (strNew !== "") { strNew += "-"; }
      const charCode = strOriginal.charCodeAt(intCount - 1);
      strNew += (charCode + 22).toString();
    }
    return strNew;
  }

  DecryptForLinkedIn(strEncrypted: string): string {
    let strOriginal = "";
    const parts = strEncrypted.split("-");
    for (const part of parts) {
      const charCode = parseInt(part, 10) - 22;
      strOriginal += String.fromCharCode(charCode);
    }
    return strOriginal;
  }

  injectLiteralFbTags(literalTags: string): void {
    const head = document.head || document.getElementsByTagName('head')[0];
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = literalTags;
    Array.from(tempDiv.children).forEach((node) => {
      head.appendChild(node);
    });
  }
}
